import React, {Component, createElement, cloneElement} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import { startSubmit, reduxForm, change, registerField, unregisterField, submit } from 'redux-form';

import './Form.less';


class Form extends Component {

    handleKeyDown = (e) => {

        if (e.keyCode === 13 && e.shiftKey === false && e.target.tagName.toLowerCase() !== 'textarea') {
            e.preventDefault();

            return false;
        }
    };

    render() {

        const { children, className, handleSubmit } = this.props;

        return (
            <form className={classnames(className, 'Form')}
                  onSubmit={handleSubmit}
                  onKeyDown={this.handleKeyDown}>
                {children}
            </form>
        );
    }
}

export default reduxForm({
    enableReinitialize: true
})(Form);



// WEBPACK FOOTER //
// ./assets/app/common/components/Form/Form.jsx